import { render, staticRenderFns } from "./AccessDenied.html?vue&type=template&id=6c110a7a&external"
import script from "./AccessDenied.ts?vue&type=script&lang=ts&external"
export * from "./AccessDenied.ts?vue&type=script&lang=ts&external"
import style0 from "./AccessDenied.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports